import { stringArrayToObject } from '../../utils/array';

import * as DatabaseService from '../../services/DatabaseService';
import { actionCreators as toastActions } from '../Toasts/actions';

import I18next from '../../config/i18n';

/* ------------- Country actions ------------- */
export const actions = stringArrayToObject(
  ['LOAD_START', 'LOAD_SUCCESS', 'LOAD_FAIL'],
  '@COUNTRIES',
);

const privateActionCreators = {
  loadStart() {
    return {
      type: actions.LOAD_START,
    };
  },
  loadSuccess(list) {
    return {
      type: actions.LOAD_SUCCESS,
      payload: { list },
    };
  },
  loadFailure(err) {
    return {
      type: actions.LOAD_FAIL,
      payload: { err },
    };
  },
};

export const actionCreators = {
  load() {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadStart());
      const result = await DatabaseService.loadCountries();
      if (result.ok) {
        dispatch(privateActionCreators.loadSuccess(result.list));
      } else {
        dispatch(privateActionCreators.loadFailure(result.message));
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18next.t('toast.countries.notLoaded.message'),
        }));
      }
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/Countries/actions.js